















































































import Vue from 'vue';
import Component from 'vue-class-component';
import Heading from '../components/Heading.vue';
import TicketMessage from '../components/TicketMessage.vue';
import TicketReply from '../components/TicketReply.vue';
import TicketStatus from '../components/TicketStatus.vue';
import ReplyForm from '../components/ReplyForm.vue';
import User from '../components/User.vue';
import LoadingIndicator from '../components/LoadingIndicator.vue';
import dateFormat from '../helpers/dateFormat';
import { TicketReplyInformation } from '../store/ticketsStore.d';

@Component({
  name: 'Ticket',

  components: {
    Heading,
    TicketMessage,
    TicketReply,
    TicketStatus,
    User,
    ReplyForm,
    LoadingIndicator,
  },
})
export default class Home extends Vue {
  replyIsOpen = false;

  get ticket() {
    return this.$store.getters.ticket;
  }

  get ticketLoadingState() {
    return this.$store.getters.ticketLoadingState;
  }

  get statusUpdateLoadingState() {
    return this.$store.getters.statusUpdateLoadingState;
  }

  get createdAtDate() {
    return dateFormat(new Date(this.ticket.created_at));
  }

  get userData() {
    return this.$store.getters.userData;
  }

  mounted() {
    this.$store.dispatch('fetchTicket', this.$route.params.id)
      .catch(() => {
        this.$router.push({ name: 'Home' });
      });
  }

  onOpenTicket() {
    this.$store.dispatch('openTicket', this.$route.params.id);

    this.$gtag.event('open', {
      event_category: 'Ticket', // eslint-disable-line @typescript-eslint/camelcase
      event_label: this.$route.params.id, // eslint-disable-line @typescript-eslint/camelcase
    });
  }

  onCloseTicket() {
    this.$store.dispatch('closeTicket', this.$route.params.id);

    this.$gtag.event('close', {
      event_category: 'Ticket', // eslint-disable-line @typescript-eslint/camelcase
      event_label: this.$route.params.id, // eslint-disable-line @typescript-eslint/camelcase
    });
  }

  onCloseReply() {
    this.replyIsOpen = false;
  }

  onAddReply() {
    this.replyIsOpen = true;
  }

  onSubmitReply(replyInformation: TicketReplyInformation) {
    const data = { ...replyInformation };
    data.ticketId = this.ticket.id;
    data.userAgent = navigator.userAgent;
    data.screenSize = `${window.screen.width}x${window.screen.height}`;

    this.$gtag.event('reply', {
      event_category: 'Ticket', // eslint-disable-line @typescript-eslint/camelcase
      event_label: this.$route.params.id, // eslint-disable-line @typescript-eslint/camelcase
    });

    console.log(data);

    this.$store.dispatch('createTicketReply', data)
      .then(() => {
        this.$store.dispatch('fetchTicket', this.ticket.id);
      });
  }
}
